import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const EditProfileModal = ({ isOpen, onClose, mode, currentData, onSave }) => {
  const [formData, setFormData] = useState({
    // Personal Info
    name: '',
    email: '',
    // Address Info (matches the saved address schema)
    alias: 'Home',
    details: '',
    city: '',
    postalCode: '',
    phone: '',
    isDefault: false
  });

  useEffect(() => {
    if (currentData) {
      setFormData(prev => ({
        ...prev,
        ...currentData
      }));
    }
  }, [currentData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-ink/40" onClick={onClose}></div>
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white rounded-2xl border border-sand shadow-card max-w-md w-full p-6">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-clay hover:text-ink transition-colors"
          >
            <FiX className="w-6 h-6" />
          </button>

          <h2 className="text-xl font-display font-normal tracking-tight text-ink mb-6">
            {mode === 'personal' ? 'Edit Personal Information' : 
             mode === 'editAddress' ? 'Edit Address' : 'Add New Address'}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === 'personal' ? (
              // Personal Information Form
              <>
                <div>
                  <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                    required
                  />
                </div>
              </>
            ) : (
              // Address Form (matches saved address schema)
              <>
                <div>
                  <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                    Label
                  </label>
                  <input
                    type="text"
                    name="alias"
                    value={formData.alias}
                    onChange={handleChange}
                    placeholder="Home, Work…"
                    className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                    Full Address Details
                  </label>
                  <textarea
                    name="details"
                    rows="3"
                    value={formData.details}
                    onChange={handleChange}
                    placeholder="Street, building, floor, apartment, nearby landmark…"
                    className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                    required
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                      Governorate / City
                    </label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                      Postal Code (optional)
                    </label>
                    <input
                      type="text"
                      name="postalCode"
                      value={formData.postalCode}
                      onChange={handleChange}
                      className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium uppercase tracking-wide text-clay mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="01012345678"
                    className="w-full rounded-xl border border-sand px-3 py-2 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
                    required
                  />
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="isDefault"
                    checked={formData.isDefault}
                    onChange={handleChange}
                    className="h-4 w-4 text-brand-500 focus:ring-brand-500/20 border-sand rounded"
                  />
                  <label className="ml-2 block text-sm text-clay">
                    Set as default address
                  </label>
                </div>
              </>
            )}

            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 rounded-xl border border-sand text-sm font-medium text-clay hover:bg-cream transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium bg-ink text-cream rounded-xl hover:bg-brand-500 hover:text-ink transition-colors"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProfileModal; 